<template>
        <b-btn data-test-path="header-show-picture-button" @click="showPicture"
               variant="plm-toolbar-secondary" class="m-1" style="width: 42px">
          <font-awesome-icon icon="image" />
        </b-btn>
</template>

<script>


import ActivityManager from "@/activity/ActivityManager";
import ImageGallery from "@/server/com/silkplm/files/images/ImageGallery";
const ImageGalleryCard = () => require("@/components/img/ImageGalleryCard");

export default {
  name: "ProductDisplayButton",

  mounted() {},

  methods: {
      async showPicture() {
        this.$emit("show-product-picture");
      }
  },

  props: {},

  data: () => ({})
}
</script>
